// extracted by mini-css-extract-plugin
export default {"exitButton":"styles_exitButton__jb8Kg"};